const wildlife = {
    id: "wildlife",
    title: "Wildlife",
    coverImage: "wildlife/wildlife.jpg",
    description: "Where instinct rules and silence speaks.",
    order: 2,
    orientation: "landscape",
    images: [
        {
            src: "wildlife/IMG_2880.jpg",
            title: "Kingfisher",
            description: "In the lakes of Bengaluru"
        },
        {
            src: "wildlife/IMG_3259.jpg",
            title: "Night Beauty",
            description: "Nightjar in Tamil Nadu"
        },
        {
            src: "wildlife/IMG_3265.jpg",
            title: "Mottled Owl",
            description: "in Tamil Nadu"
        },
        {
            src: "wildlife/IMG_7791.jpg",
            title: "Raptor in Lanka!",
            description: "Sri Lanka"
        }
        ,
        {
            src: "wildlife/IMG_7825.jpg",
            title: "What a stare!",
            description: "Sri Lanka"
        }
        ,
        {
            src: "wildlife/IMG_7900.jpg",
            title: "Gentle Giant",
            description: "Sri Lanka"
        }
        ,
        {
            src: "wildlife/IMG_9255.jpg",
            title: "Agama",
            description: "in Jerash"
        }
        ,
        {
            src: "wildlife/IMG_9360.jpg",
            title: "A Pair of Birds",
            description: "Bengaluru"
        }
        ,
        {
            src: "wildlife/IMG_9380.jpg",
            title: "Another Raptor",
            description: "In the lakes of Bengaluru"
        }
        ,
        {
            src: "wildlife/IMG_9416.jpg",
            title: "A Big Billed Stork",
            description: "Open Billed stork in Bengaluru"
        }
        ,
        {
            src: "wildlife/IMG_9422.jpg",
            title: "Nature meets Man",
            description: "A Muniya in the Lakes of Bengaluru"
        }
    ]
};

export default wildlife;